import { Fragment, useState } from "react";
import { H3, LI, UL } from "../../../AbstractElements";
import { H_MENU } from "../../../Data/Sidebar/HorizontalMenu";
import { SubMenu } from "./SubMenu";
import { useTranslation } from "react-i18next";

const HorizontalSidebar = () => {
  const [isOpen, setIsOpen] = useState([]);
  const { t } = useTranslation();


  return (
    <>
      <div className="page-sub-header">
        <div className="body-header">
          <UL className="sidebar-body-menu d-flex flex-row simple-list">
            {H_MENU.map((item, index) => (
              <Fragment key={index}>
                {item.title && (
                  <LI>
                    <div>
                      <H3 className="lan-1">{t(item.title)}</H3>
                      <span className="lan-2">{t(item.subTitle)}</span>
                    </div>
                    <UL className="sidebar-body-mainmenu">
                      <SubMenu menu={item.menu} isOpen={isOpen} setIsOpen={setIsOpen} level={0} />
                    </UL>
                  </LI>
                )}
              </Fragment>
            ))}
          </UL>
        </div>
      </div>
    </>
  );
};

export default HorizontalSidebar;